module.exports = __webpack_public_path__ + "media/images/profiles/profile-6-7e98b1a7864e8d0fc2452939ac5b921e.png";